import { defaultBookshelfGroupId } from "@shared/bookshelf";
import type { BookshelfViewItem, SearchResult } from "../api";

export function createSearchResultFromBookshelfItem(item: BookshelfViewItem): SearchResult {
  return {
    book: item.book,
    sources: item.sources,
  };
}

export function createSearchResultDetailItem(result: SearchResult, activeSourceId?: string): BookshelfViewItem {
  return {
    item: {
      id: `search-detail:${result.book.id}`,
      bookId: result.book.id,
      kind: result.book.kind,
      status: "search-detail",
      groupId: defaultBookshelfGroupId,
      activeSourceId: activeSourceId ?? result.sources[0]?.sourceId,
    },
    book: result.book,
    sources: result.sources,
    progress: null,
  };
}

export function findSearchResultShelfItem(result: SearchResult, bookshelf: BookshelfViewItem[]): BookshelfViewItem | undefined {
  return bookshelf.find(item => item.book.id === result.book.id) ?? bookshelf.find(item => hasSameSource(item, result));
}

function hasSameSource(item: BookshelfViewItem, result: SearchResult): boolean {
  return item.sources.some(source =>
    result.sources.some(resultSource =>
      source.sourceId === resultSource.sourceId && source.sourceBookId === resultSource.sourceBookId,
    ),
  );
}
